// Requests (VERA Workforce, phase 1): what a person asks for from Help (and later Build, chat, voice and uploads) is
// read by VERA on the server into a card; the person approves, changes or sets it aside. Nothing happens before that,
// and the VERANeural team only ever receives the summary the person approved.
import { cpFetch } from "./controlPlane";

export type RequestCard = {
  type: "question" | "workspace" | "document" | "account" | "payments" | "bug" | "feature" | "live";
  understood: string; steps: string[]; changesForYou?: string; forHq?: string; answer?: string; question?: string;
};

export type StudioRequest = {
  id: string; source: string; kind: string; message: string; page?: string; created: number;
  state: "reading" | "unread" | "awaiting" | "answered" | "build" | "sent" | "closed";
  card?: RequestCard; repeatOf?: string; attachments: string[];
};

export type RequestInput = {
  source: "help" | "build" | "chat" | "voice" | "upload"; kind: string; message: string; page: string; device: string;
  replyTo?: string; attachments?: { name: string; text: string }[]; language?: string;
};

type Answer = { status: string; request?: StudioRequest; error?: string };

export const requests = {
  create: (getToken: () => Promise<string | null>, input: RequestInput) =>
    cpFetch<Answer>(getToken, "/v1/help/requests", { method: "POST", body: JSON.stringify(input) }),
  mine: (getToken: () => Promise<string | null>) => cpFetch<{ requests: StudioRequest[] }>(getToken, "/v1/help/requests"),
  decide: (getToken: () => Promise<string | null>, id: string, decision: "approve" | "change" | "notnow", text?: string) =>
    cpFetch<Answer>(getToken, `/v1/help/requests/${encodeURIComponent(id)}/decide`, { method: "POST", body: JSON.stringify({ decision, text }) }),
};

/** The work the VERANeural team does (the rest happens in the person's own workspace). */
export const forTheTeam = (c: RequestCard) => ["account", "payments", "bug", "feature", "live"].includes(c.type);
